var _path, _mask, _g, _mask2, _g2, _mask3, _g3, _mask4, _g4, _mask5, _g5, _mask6, _g6, _mask7, _g7, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogo3030 = function SvgLogo3030(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 0H0v128h128V0Z",
    fill: "url(#logo_30_30_svg__a)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "logo_30_30_svg__b",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 25,
    width: 60,
    height: 84
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5 25.7H37.6c-3.1 0-5.6 2.5-5.6 5.6v71.2c0 3.1 2.5 5.6 5.6 5.6h48.7c3.1 0 5.6-2.5 5.6-5.6V48.2L69.5 25.7Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo_30_30_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5 25.7H37.6c-3.1 0-5.6 2.5-5.6 5.6v71.2c0 3.1 2.5 5.6 5.6 5.6h48.7c3.1 0 5.6-2.5 5.6-5.6V48.2l-13.1-9.4-9.3-13.1Z",
    fill: "#0F9D58"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "logo_30_30_svg__c",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 25,
    width: 60,
    height: 84
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5 25.7H37.6c-3.1 0-5.6 2.5-5.6 5.6v71.2c0 3.1 2.5 5.6 5.6 5.6h48.7c3.1 0 5.6-2.5 5.6-5.6V48.2L69.5 25.7Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo_30_30_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 66v27.2h30V66H47Zm13.1 23.4h-9.4v-4.7h9.4v4.7Zm0-7.5h-9.4v-4.7h9.4v4.7Zm0-7.5h-9.4v-4.7h9.4v4.7Zm13.1 15h-9.4v-4.7h9.4v4.7Zm0-7.5h-9.4v-4.7h9.4v4.7Zm0-7.5h-9.4v-4.7h9.4v4.7Z",
    fill: "#F1F1F1"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "logo_30_30_svg__d",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 25,
    width: 60,
    height: 84
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5 25.7H37.6c-3.1 0-5.6 2.5-5.6 5.6v71.2c0 3.1 2.5 5.6 5.6 5.6h48.7c3.1 0 5.6-2.5 5.6-5.6V48.2L69.5 25.7Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo_30_30_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1 46.6 92 67.4V48.2l-20.9-1.6Z",
    fill: "url(#logo_30_30_svg__e)"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "logo_30_30_svg__f",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 25,
    width: 60,
    height: 84
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5 25.7H37.6c-3.1 0-5.6 2.5-5.6 5.6v71.2c0 3.1 2.5 5.6 5.6 5.6h48.7c3.1 0 5.6-2.5 5.6-5.6V48.2L69.5 25.7Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo_30_30_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.425 25.742v16.9c0 3.1 2.5 5.6 5.6 5.6h16.9l-22.5-22.5Z",
    fill: "#87CEAC"
  }))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "logo_30_30_svg__g",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 25,
    width: 60,
    height: 84
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5 25.7H37.6c-3.1 0-5.6 2.5-5.6 5.6v71.2c0 3.1 2.5 5.6 5.6 5.6h48.7c3.1 0 5.6-2.5 5.6-5.6V48.2L69.5 25.7Z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo_30_30_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.6 25.7c-3.1 0-5.6 2.5-5.6 5.6v.5c0-3.1 2.5-5.6 5.6-5.6h31.9v-.5H37.6Z",
    fill: "#fff"
  }))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "logo_30_30_svg__h",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 25,
    width: 60,
    height: 84
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5 25.7H37.6c-3.1 0-5.6 2.5-5.6 5.6v71.2c0 3.1 2.5 5.6 5.6 5.6h48.7c3.1 0 5.6-2.5 5.6-5.6V48.2L69.5 25.7Z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo_30_30_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M86.3 107.7H37.6c-3.1 0-5.6-2.5-5.6-5.6v.5c0 3.1 2.5 5.6 5.6 5.6h48.7c3.1 0 5.6-2.5 5.6-5.6v-.5c.1 3.1-2.5 5.6-5.6 5.6Z",
    fill: "#263238"
  }))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "logo_30_30_svg__i",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 25,
    width: 60,
    height: 84
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5 25.7H37.6c-3.1 0-5.6 2.5-5.6 5.6v71.2c0 3.1 2.5 5.6 5.6 5.6h48.7c3.1 0 5.6-2.5 5.6-5.6V48.2L69.5 25.7Z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo_30_30_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M75.1 48.2c-3.1 0-5.6-2.5-5.6-5.6v.4c0 3.1 2.5 5.6 5.6 5.6H92v-.5H75.1v.1Z",
    fill: "#263238"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91 18.9c2.3 0 4.6.5 6.8 1.4 1 .4 2 1 3 1.6.9.6 1.8 1.3 2.6 2.1s1.5 1.7 2.1 2.6c.6.9 1.2 1.9 1.6 3 .9 2.1 1.4 4.4 1.4 6.8 0 2.3-.5 4.6-1.4 6.8-.4 1-1 2-1.6 3-.6.9-1.3 1.8-2.1 2.6s-1.7 1.5-2.6 2.1c-.9.6-1.9 1.2-3 1.6-2.1.9-4.4 1.4-6.8 1.4-2.3 0-4.6-.5-6.8-1.4-1-.4-2-1-3-1.6-.9-.6-1.8-1.3-2.6-2.1s-1.5-1.7-2.1-2.6C75.9 45 75.4 44 75 43c-.9-2.1-1.4-4.4-1.4-6.8 0-2.3.5-4.6 1.4-6.8.4-1 1-2 1.6-3 .6-.9 1.3-1.8 2.1-2.6s1.7-1.5 2.6-2.1c.9-.6 1.9-1.2 3-1.6 2-.8 4.3-1.2 6.7-1.2Zm0-1.2c-10.2 0-18.5 8.3-18.5 18.5S80.8 54.7 91 54.7s18.5-8.3 18.5-18.5-8.3-18.5-18.5-18.5Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6 36.2c0 6.1 3.5 11.4 8.7 13.9L76.9 30c-.9 1.9-1.3 4-1.3 6.2Zm25.8-.7c0-1.9-.7-3.2-1.3-4.2-.8-1.3-1.5-2.3-1.5-3.6 0-1.4 1.1-2.7 2.6-2.7h.2c-2.7-2.5-6.4-4-10.4-4-5.4 0-10.1 2.8-12.9 6.9h1c1.6 0 4.1-.2 4.1-.2.8 0 .9 1.2.1 1.3 0 0-.8.1-1.8.1l5.6 16.7 3.4-10.1-2.4-6.7c-.8 0-1.6-.1-1.6-.1-.8 0-.7-1.3.1-1.3 0 0 2.5.2 4.1.2 1.6 0 4.1-.2 4.1-.2.8 0 .9 1.2.1 1.3 0 0-.8.1-1.8.1l5.6 16.6 1.6-5c.7-2.3 1.1-3.8 1.1-5.1Zm-10.2 2.1L86.6 51c1.4.4 2.8.6 4.4.6 1.8 0 3.5-.3 5.1-.9 0-.1-.1-.1-.1-.2l-4.8-12.9Zm13.3-8.8c.1.5.1 1 .1 1.6 0 1.6-.3 3.3-1.2 5.5l-4.7 13.6c4.6-2.7 7.7-7.6 7.7-13.3 0-2.6-.7-5.2-1.9-7.4Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_30_30_svg__a",
    x1: 97.336,
    y1: 110.105,
    x2: 9.358,
    y2: -11.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08CF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2FFBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_30_30_svg__e",
    x1: 81.522,
    y1: 48.36,
    x2: 81.522,
    y2: 67.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0.02
  })))));
};

export default SvgLogo3030;